import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import { Button, Spinner, TextInput } from '@telus-uds/components-web';

import { EditOverlay } from '../../css';
import request from '../../../../../../../utils/request';

const Overlay = ({ setInEditMode, id, name, fetchData }) => {
  const [dealershipName, setDealershipName] = useState(name);
  const [validationError, setValidationError] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const prevNameRef = useRef();

  const resetState = () => {
    setIsUpdating(false);
    setInEditMode(false);
    setValidationError(false);
    fetchData();
  };

  const updateName = async () => {
    if (!name || name === dealershipName) {
      setValidationError(true);
      return;
    }
    setIsUpdating(true);
    try {
      const result = await request.post(`/dealerships/${id}`, {
        name: dealershipName
      });
      if (result && result.status === 200) {
        fetchData();
      }
    } catch (err) {
      resetState();
      throw err;
    }
  };

  useEffect(() => {
    if (prevNameRef.current && prevNameRef.current !== dealershipName)
      setInEditMode(false);

    prevNameRef.current = dealershipName;
  }, [name]);

  return (
    <EditOverlay>
      <Spinner label="updating..." show={isUpdating}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
            width: '100%'
          }}
        >
          <TextInput
            label="Dealership Name"
            defaultValue={dealershipName}
            value={dealershipName}
            onChange={(value) => setDealershipName(value)}
            feedback={validationError && 'error'}
            error={validationError && 'Name cannot be empty of same as before'}
          />
          <Button type="button" variant={{ priority: 'high' }} onPress={updateName}>
            Update
          </Button>
          <Button
            variant={{ priority: 'low' }}
            type="button"
            onPress={() => setInEditMode(false)}
          >
            Cancel
          </Button>
        </div>
      </Spinner>
    </EditOverlay>
  );
};

Overlay.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  setInEditMode: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default Overlay;
